module.exports = __webpack_public_path__ + "img/juan.714f2845.jpg";